import { render } from "./Products.vue?vue&type=template&id=75a2c6d6&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=75a2c6d6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a2c6d6"]])

export default __exports__